import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";

function TroubleshootQRSticker({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({
    qr_sticker_distribution: false,
  });

  // Yes/No options
  const YES_NO_OPTIONS = ["Yes", "No"];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPrimaryDetails(prev => ({ ...prev,
      [name]: value,
    }));

    // Clear error when user makes a selection
    if (isError[name]) {
      setIsError({
        ...isError,
        [name]: false,
      });
    }
  };

  const validateForm = () => {
    const errors = {
      qr_sticker_distribution: !primaryDetails.qr_sticker_distribution,
    };

    setIsError(errors);

    const hasErrors = Object.values(errors).some(error => error);
    if (hasErrors) {
      toast.error("Please select Yes or No", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const handleNext = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (validateForm()) {
      if (primaryDetails.qr_sticker_distribution === "Yes") {
        navigation.go("troubleshoot-qr-sticker-photo");
      } else {
        navigation.go("troubleshoot-p1-sticker");
      }
    }
  };

  const handleBack = () => {
    navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">

          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">Troubleshoot QR Sticker</h4>
              <p className="form-desc">Please indicate if this merchant has a QR Sticker</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">
                <Form>
                  {/* Yes/No Question */}
                  <Form.Group className="mb-5" controlId="qr_sticker_distribution">
                    <Form.Label className="form-label">
                      Nagbigay o nagdikit ka ba ng Troubleshoot QR Sticker? <span className="form-required">*</span>
                    </Form.Label>
                    <div className="form-radio-group">
                      {YES_NO_OPTIONS.map((option, index) => (
                        <div
                          key={`troubleshoot-qr-${index}-${option}`}
                          className={`form-radio-item${primaryDetails.qr_sticker_distribution === option ? " selected" : ""}`}
                        >
                          <div className="form-radio-flex">
                            <Form.Check
                              type="radio"
                              name="qr_sticker_distribution"
                              value={option}
                              label={option}
                              onChange={handleInputChange}
                              checked={primaryDetails.qr_sticker_distribution === option}
                              className="form-radio"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    {isError.qr_sticker_distribution && (
                      <div className="form-error">
                        Please select Yes or No
                      </div>
                    )}
                  </Form.Group>

                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      type="button"
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      type="button"
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                    >
                      Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>

        </Row>
      </Container>
    </div>
  );
}

export default TroubleshootQRSticker;
